import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { DownloadSimple, FileXls, FilePdf } from "@phosphor-icons/react";

/** Exports the summary of every campaign (Excel / PDF). */
export function CampaignExport() {
  const [busy, setBusy] = useState(false);
  const download = async (fmt) => {
    setBusy(true);
    try {
      const { data, headers } = await api.get(`/campaigns/export/${fmt}`, { responseType: "blob" });
      const name = /filename=([^;]+)/.exec(headers["content-disposition"] || "")?.[1] || `sdm-campanas.${fmt}`;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(data); a.download = name; a.click();
      URL.revokeObjectURL(a.href);
      toast.success(`Reporte de campañas exportado (${fmt === "xlsx" ? "Excel" : "PDF"})`);
    } catch { toast.error("No se pudo exportar el reporte"); } finally { setBusy(false); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-1.5" disabled={busy} data-testid="campaigns-export">
          <DownloadSimple size={16} /> {busy ? "Exportando…" : "Exportar reporte"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => download("xlsx")} data-testid="campaigns-export-xlsx"><FileXls size={16} className="mr-2" /> Excel</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download("pdf")} data-testid="campaigns-export-pdf"><FilePdf size={16} className="mr-2" /> PDF</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CampaignExport;
